import axios from "../app/axios";
import PATH from "./paths";

export const getRegistrationCodes = async (adminId: number) => {
    const response = await axios.get(`${PATH.REGISTRATION_CODES}?adminId=${adminId}`);
    return response.data;
};

export const generateRegistrationCode = async (data?: { email?: string }) => {
    const response = await axios.post(PATH.GENERATE_REGISTRATION_CODE, data);
    return response.data;
};

export const approveRegistration = async (registrationId: number) => {
    const response = await axios.patch(PATH.APPROVE_REGISTRATION.replace(":id", registrationId.toString()));
    return response.data;
};

export const rejectRegistration = async (registrationId: number) => {
    const response = await axios.patch(PATH.REJECT_REGISTRATION.replace(":id", registrationId.toString()));
    return response.data;
};

export const getRegistrationCodeUsers = async () => {
    const response = await axios.get(PATH.REGISTRATION_CODE_USERS);
    return response.data;
};
